import React from 'react';
import { WhyWatcho } from './WhyWatcho';
import './MyStyles/style.css';
import './MyStyles/responsive.css';

export const ContentBottom = () => {
    return (
        <>
            <div className="friendsFamily container my-5">
                <div className="for-desktop">
                    <h2 className="How-it-works">How it works</h2>
                    <div className="row my-4">
                        <div className="col-md-4 step">
                            <div className="step-icon bg-acctome1 text-white">1</div>
                            <div className="step-text">
                                <h5>Add vouchers to Cart</h5>
                                <p>10 to 25 coupons</p>
                            </div>
                        </div>
                        <div className=" col-md-4 step">
                            <div className="step-icon bg-acctome2 text-white">2</div>
                            <div className="step-text">
                                <h5>Verify your info</h5>
                                <p>Your info is safe with us</p>
                            </div>
                        </div>
                        <div className=" col-md-4 step">
                            <div className="step-icon bg-acctome3 text-white">3</div>
                            <div className="step-text">
                                <h5>Make Payment</h5>
                                <p>90 days voucher validity</p>
                            </div>
                        </div>
                    </div>

                </div>


                {/*<!-- =================== How it works for mobile===================== -->*/}

                <div className="process-flow">
                    <h2 className="process-title">How it works</h2>
                    <div className="timeline">
                        <div className="timeline-step">
                            <div className="step-icon" style={{ background: 'linear-gradient(90deg,#E42956 0%,#FD3438 125%)' }} >1</div>
                            <div className="step-details">
                                <h3 className="step-heading">Add vouchers to cart</h3>
                                <p className="step-description">10 to 100 coupons</p>
                            </div>
                        </div>
                        <div className="timeline-step one-above">
                            <div className="step-icon" style={{ background: 'linear-gradient(90deg,#FD313A 0%,#FF9800 100%)' }} >2</div>
                            <div className="step-details">
                                <h3 className="step-heading">Verify your info</h3>
                                <p className="step-description">Your info is safe with us</p>
                            </div>
                        </div>
                        <div className="timeline-step">
                            <div className="step-icon" style={{ background: 'linear-gradient(90deg,#D1C400 -50%,#2447B7 100%)' }} >3</div>
                            <div className="step-details">
                                <h3 className="step-heading">Make Payments</h3>
                                <p className="step-description">90 days voucher validity</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/*<!-- =================== How it works for mobile===================== -->*/}



                
                <WhyWatcho/>
            </div>
        </>
    );
}